import { Link } from 'react-router-dom';
import { TRADES, CALCULATORS } from '@/lib/calculators';
import { ArrowRight } from 'lucide-react';
import Seo from '@/components/Seo';

export default function TradesIndex() {
  const SITE = 'https://tradesmateuk.co.uk';
  const jsonLd = {
    '@context': 'https://schema.org', '@type': 'CollectionPage',
    name: 'UK Trade Calculators by Trade',
    url: `${SITE}/trades`,
    description: 'Free UK trade calculators grouped by trade — bricklayers, groundworkers, plasterers, plumbers, electricians, roofers, tilers and more.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: TRADES.map((t, i) => ({
        '@type': 'ListItem', position: i + 1, name: t.name,
        url: `${SITE}/trades/${t.slug}`,
      })),
    },
  };
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Seo
        title="Trades — Pick Your Trade Calculators"
        description="Browse TradesMate's free UK trade calculators grouped by trade: bricklayers, groundworkers, plasterers, plumbers, electricians, roofers, tilers and more."
        path="/trades"
        jsonLd={jsonLd}
      />
      <header className="mb-10">
        <p className="text-xs uppercase tracking-widest text-brand font-semibold">Trades</p>
        <h1 className="font-display font-semibold text-4xl sm:text-5xl uppercase tracking-tight mt-1">Pick a trade</h1>
        <p className="text-slate-600 mt-2 max-w-2xl">All calculators are grouped by trade. Tap a card to jump in.</p>
      </header>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {TRADES.map((t) => {
          const count = CALCULATORS.filter((c) => c.trade === t.slug).length;
          return (
            <Link
              key={t.slug}
              to={`/trades/${t.slug}`}
              data-testid={`trade-list-card-${t.slug}`}
              className="tm-card tm-card-interactive p-6 flex flex-col gap-3"
            >
              <div className="flex items-center justify-between">
                <span className="tm-chip tm-chip-orange">{count} calc{count !== 1 ? 's' : ''}</span>
                <ArrowRight size={20} className="text-slate-500"/>
              </div>
              <h2 className="font-display font-bold text-xl uppercase tracking-tight">{t.name}</h2>
              <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{t.tagline}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
